import { Skeleton as MuiSkeleton } from "@mui/material";
import { forwardRef } from "react";


const Skeleton = forwardRef(
  ({ variant = "rounded", animation = "wave", ...props }, ref) => {
    return (
      <MuiSkeleton
        ref={ref}
        variant={variant}
        animation={animation}
        {...props}
      />
    );
  }
);
export default Skeleton;
